'use client';

import React from 'react';
import { Image as CImage } from 'antd';

interface IProps {
  src: any;
  preview: boolean;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const AntImage: React.FC<IProps> = ({
  src,
  preview,
  alt,
  className,
  style,
}) => (
  <CImage
    src={src}
    preview={preview ? { mask: 'Xem hình ảnh' } : false}
    alt={alt}
    className={className}
    style={style}
    loading="lazy"
  />
);

export default AntImage;
